import React, { FC, ReactNode } from 'react'
import { withProps } from '@utils/hoc'
import { SummaryText } from '@components/order'
import colors from '@const/colors.json'
import { SummaryBox } from '@components/order/Summary'

type CheckoutViewProps = {
  list: ReactNode
  summary?: ReactNode
}

const CheckoutView: FC<CheckoutViewProps> = ({ list, summary }) => {
  return (
    <div className="mt-[15px] flex flex-col gap-y-[20px] sm:gap-x-[30px] lg:flex-row">
      <ul className="flex-grow">{list}</ul>
      <div className="mx-auto w-[90vw] max-w-[350px]">{summary ? summary : null}</div>
    </div>
  )
}

export default CheckoutView

export const Text = withProps(SummaryText, {
  primaryColor: colors.white,
  secondaryColor: colors.blue5
})

export const Box = withProps(SummaryBox, {
  primaryColor: colors.white,
  secondaryColor: colors.blue5
})
